import { AuditService } from '../services'

const exportMovimientos = (filters) => {
  return new Promise(async (resolve, reject) => {
    await AuditService.exportExcel(filters)
      .then(response => resolve(response.data))
      .catch(err => reject(err))
  })
}

export default exportMovimientos
